var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.84846 7.68958L12.7572 11.6016C13.0745 11.919 13.0745 12.4342 12.7572 12.7516C12.5989 12.9103 12.3909 12.9899 12.1828 12.9899C11.9748 12.9899 11.7668 12.9103 11.6081 12.7516L7.69939 8.83964C6.90393 9.40592 5.93389 9.7424 4.8835 9.7424C2.1957 9.7424 0.0166016 7.56132 0.0166016 4.8712C0.0166016 2.18109 2.1957 0 4.8835 0C7.57128 0 9.75038 2.18109 9.75036 4.8712C9.75036 5.92258 9.41424 6.89355 8.84846 7.68958ZM7.20781 7.19719L7.52681 6.74825C7.92045 6.19454 8.12847 5.54545 8.12811 4.8712C8.12811 3.08062 6.67264 1.62373 4.8835 1.62373C3.09436 1.62373 1.63891 3.08062 1.63891 4.8712C1.63891 6.66176 3.09436 8.11867 4.8835 8.11867C5.55736 8.11867 6.20596 7.91042 6.75911 7.51666L7.20781 7.19719Z",
  fill: "#7D86A9"
});

function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.f2b0f567.svg";
export { ForwardRef as ReactComponent };